import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  BoosterPlan,
  TargetTest,
} from '@backrs_ui/grow-ui/src/redux/satActBooster/satActBooster.types';

const STRINGS = appStrings.modules.satActBooster.results.planAtAGlance.summary;

const TEST_LABEL: Record<TargetTest, string> = { act: 'ACT', sat: 'SAT' };

/**
 * The "Plan at a Glance" summary markdown, derived from the computed plan. Content- and
 * timed-day counts come from the calendar's day kinds; the wording lives in appStrings so it
 * can change without a data backfill. Renders as prose paragraphs, not a bulleted breakdown.
 */
export const buildPlanSummary = (test: TargetTest | null, plan: BoosterPlan): string => {
  const label = test ? TEST_LABEL[test] : 'test';
  const weeks = plan.stats.totalWeeks;
  const contentDays = plan.days.filter((day) => day.kind === 'study').length;
  const timedDays = plan.days.filter((day) => day.kind === 'timed').length;
  const totalSessions = contentDays + timedDays;

  const sessions =
    timedDays > 0
      ? STRINGS.sessionsWithTimed(weeks, totalSessions, contentDays, timedDays)
      : STRINGS.sessionsNoTimed(weeks, totalSessions);

  const paragraphs = [`${STRINGS.intro(label)} ${sessions}`, STRINGS.focus(label)];

  if (plan.insufficientSchedule?.flag) {
    paragraphs.push(STRINGS.insufficient);
  }

  return paragraphs.join('\n\n');
};
